import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Paper } from 'material-ui'
import './Landing.css';
import jeff from '../assets/images/jeff.jpg';
import landing from '../assets/images/landing3.jpg';
import github from '../assets/images/github.png';
import email from '../assets/images/email.png';
import facebook from '../assets/images/facebook.png';
import linkedin from '../assets/images/linkedin.png';
import youtube from '../assets/images/youtube.png';
import strava from '../assets/images/strava.png';

const greetings = [
  {
    text: "Aloha, I'm ",
    name: 'Jeff',
    period: '.'
  },
  {
    text: "こんにちは、僕は",
    name: 'ジェフ',
    period: 'です。'
  },
  {
    text: "你好，我是",
    name: '傑夫',
    period: '。'
  }
];

const imgStyle = {
  backgroundImage: "url("+landing+")"
};

const style = {
  backgroundImage: "url("+jeff+")"
};


class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {greetingCounter: 0};
    this.onJeffClick = this.onJeffClick.bind(this);
  }

  onJeffClick() {
    if(this.state.greetingCounter === greetings.length - 1) {
      this.setState({greetingCounter: 0});
    } else {
      this.setState({greetingCounter: (this.state.greetingCounter + 1)});
    }
  }

  render() {
    return (
      <div style={{marginTop: '-20px'}} >
        <div className="Landing-container" style={imgStyle}>
          <div className="Landing-info">
            <h2><b>{greetings[this.state.greetingCounter].text}<Link className="Landing-jefflink" to="/about">{greetings[this.state.greetingCounter].name}</Link>{greetings[this.state.greetingCounter].period}</b></h2>
            <Paper zDepth={5} className="Landing-jeff" style={style} circle={true} onClick={this.onJeffClick} />
          </div>
          <div className="Landing-icons-container">
            <a href="https://www.github.com/morisan" target="_blank"><Image className="Landing-icons" style={{width: 33, borderBottomWidth: 2}} src={github} /></a>
            <a href="https://www.linkedin.com/in/jeffmori" target="_blank"><Image className="Landing-icons" src={linkedin} /></a>
            <a href="https://www.strava.com/athletes/11542040" target="_blank"><Image className="Landing-icons" src={strava} /></a>
            <a href="https://www.youtube.com/user/mantiz007" target="_blank"><Image className="Landing-icons" src={youtube} /></a>
            <a href="https://www.facebook.com/jeff.mori" target="_blank"><Image className="Landing-icons" src={facebook} /></a>
            <a href="mailto:jeff.mori@gmail.com?Subject=Aloha"><Image className="Landing-icons" src={email} /></a>
          </div>
        </div>
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/pages/Landing.js